import InventoryIcon from './component'

export default InventoryIcon
